import { render, staticRenderFns } from "./CustomLink.1.vue?vue&type=template&id=4ffbdb3e&"
import script from "./CustomLink.1.vue?vue&type=script&lang=js&"
export * from "./CustomLink.1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/eric/projects/musical/musical-admin-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ffbdb3e')) {
      api.createRecord('4ffbdb3e', component.options)
    } else {
      api.reload('4ffbdb3e', component.options)
    }
    module.hot.accept("./CustomLink.1.vue?vue&type=template&id=4ffbdb3e&", function () {
      api.rerender('4ffbdb3e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CustomLink.1.vue"
export default component.exports